import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {
    IVerificationPeriod
} from "../../../../../../utils/interfaces/lwg_dashboard/verification_period/IVerificationPeriod";
import {useAuth} from "../../../../../../utils/contexts/auth-context";


const useApiUpdateVerificationPeriod = (): UseMutationResult<IVerificationPeriod, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()
    const {put} = useApiCalls()

    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IVerificationPeriod> {
        try {
            const response = await put(`/api/company/${company_token}/lwg_dashboard/verification_period/${pk}`, data);
            return response.data as IVerificationPeriod;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IVerificationPeriod, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ["useApiGetVerificationPeriod"]});
        },
    });
};

export default useApiUpdateVerificationPeriod;